export class User {
    id: string
    token: string;
    refreshToken: string;
    nombre: string;
    apellidoPaterno: string;
    apellidoMaterno: string;
    nombreCompleto: string;
    permisos: any[];
    correo:string;
    idCliente:number;
    cartItems?: Array<any>;
    status?: any; 
    idUsuario?: string;
}